import { createSlice } from "@reduxjs/toolkit";
import {
  showTransactionAdjustment,
  showTransactionAdjustmentData,
  getTransactionApproval,
  putTransactionAdjustment,
} from "../actions";

const initialState = {
  transaction: [],
  transactionData: [],
  transactionsApproval: [],
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {},
  extraReducers: {
    [showTransactionAdjustment.fulfilled]: (state, action) => {
      state.transaction = action.payload || [];
    },
    [putTransactionAdjustment.fulfilled]: (state, action) => {
      state.transaction = state.transaction.map((item) =>
        item.Oid === action.payload.Oid ? action.payload : item
      );
    },

    [showTransactionAdjustmentData.fulfilled]: (state, action) => {
      state.transactionData = action.payload || [];
    },
    [getTransactionApproval.fulfilled]: (state, action) => {
      state.transactionsApproval = action.payload || [];
    },
  },
});

export const responseTransaction = (state) => state.transaction;

export default transactionSlice.reducer;
